import {
    RESET_GROUPS,
    GET_GROUPS,
    SET_GROUPS,
    API_ERROR,
    GET_GROUP,
    SET_GROUP,
  } from "./actionTypes";

  export const resetGroups = () => {
    return {
      type: RESET_GROUPS,
      payload: {},
    };
  };
  export const getGroups = (idCompany, page, qnt) => {
    return {
      type: GET_GROUPS,
      payload: { idCompany, page, qnt },
    };
  };
  
  export const loadGroups = (data, qtdDefault) => {
    const maxPage = Math.ceil(data.total / qtdDefault);
    var paging = Array.from({ length: maxPage }, (v, k) => k + 1);
  
    return {
      type: SET_GROUPS,
      payload: { ...data, paging },
    };
  };
  
  export const apiError = (error) => {
    return {
      type: API_ERROR,
      payload: error,
    };
  };

  export const getGroup = (idCompany, idGroup) => {
    return {
      type: GET_GROUP,
      payload: { idCompany, idGroup },
    };
  };
  export const setGroup = (data) => {
    return {
      type: SET_GROUP,
      payload: { data },
    };
  };